module.exports = __webpack_public_path__ + "img/lens-report-comparative.6589786b.png";